import MainTemplate from "@/components/Templates/MainTemplate";

import { SVGSprite } from "@/components/Atoms";
import Typography from "@/foundation/Typography/V2";

import data from "./threads";

import { classNameGenerator } from "@/utils";

import styles from "./CommunityThreadListingPage.module.scss";

interface CommunityThreadListingPageProps {}

const CommunityThreadListingPage: React.FC<
  CommunityThreadListingPageProps
> = () => {
  const cls = classNameGenerator(styles);

  return (
    <MainTemplate>
      <div className={cls("communityThreadListingPage")}>
        <div className={cls("headerContainer")}>
          <SVGSprite icon="icon-brand-logo-light" className={cls("logo")} />
          <Typography variant="heading1" className={cls("heading")}>
            All our Community posts
          </Typography>
        </div>
        <div className={cls("container")}>
          {data?.map(({ title, url }, index) => (
            <Typography
              key={index}
              variant="link1"
              href={url}
              className={cls("thread")}
            >
              {title}
            </Typography>
          ))}
        </div>
      </div>
    </MainTemplate>
  );
};

export default CommunityThreadListingPage;
